import { Button, ButtonGroup, ButtonGroupProps } from '@chakra-ui/react';
import { FiPlus } from 'react-icons/fi';

export interface SearchTableButtonGroupProps extends ButtonGroupProps {
  entityName: string;
  onNewEntity?: () => void;
}
export const SearchTableButtonGroup = (props: SearchTableButtonGroupProps) => {
  const { onNewEntity, entityName, ...rest } = props;
  return (
    <ButtonGroup {...rest}>
      {onNewEntity && (
        <Button
          leftIcon={
            // @ts-ignore
            <FiPlus />
          }
          variant={'solid'}
          colorScheme="blue"
          onClick={onNewEntity}
        >
          {entityName}
        </Button>
      )}
    </ButtonGroup>
  );
};
